<template>
    <footer class="section footer-area">
        <!-- Footer Top -->
        <div class="footer-top ptb_100">
            <div class="container">
              <div class="row">
                    <div class="col-12 col-sm-6 col-lg-3">
                        <!-- Footer Items -->
                        <div class="footer-items">
                            <!-- Footer Title -->
                            <h3 class="footer-title text-uppercase mb-2">VM Partners</h3>
                            <ul>
                                <li class="py-2"><a href="mailto:office@vmpartners.rs">E: office@vmpartners.rs</a></li>
                                <li class="py-2"><a href="tel:+381 (0) 60 4400 841">T: +381 (0) 60 4400 841</a></li>
                                <li class="py-2"><a href="tel:+381 (0) 65 3400 331">T: +381 (0) 65 3400 331</a></li>
                                <li class="py-2"><a target="_blank" href="https://goo.gl/maps/NgHcTz4fzL1EmCmo7">Beograd – Vojvode Stepe 327/PP2</a></li>
                                <li class="py-2"><a target="_blank" href="https://goo.gl/maps/kEyVDgkytE1zMzKCA">Novi Sad – Bulevar cara Lazara 106/7</a></li>
                                <li class="py-2"><a target="_blank" href="https://goo.gl/maps/cZU1Ponx5tjW6Kq76">Leskovac – Alekse Nenadovića 12</a></li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-12 col-sm-6 col-lg-3">
                        <!-- Footer Items -->
                        <div class="footer-items">
                            <!-- Footer Title -->
                            <h3 class="footer-title text-uppercase mb-2">O Nama</h3>
                            <ul>
                                <li class="py-2"><a href="#">Vizija</a></li>
                                <li class="py-2"><a href="#">Partneri</a></li>
                                <li class="py-2"><a href="#">Reference</a></li>
                                <li class="py-2"><a href="#">Karijera</a></li>
                                <li class="py-2"><a href="#">Privatnost</a></li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-12 col-sm-6 col-lg-3">
                        <!-- Footer Items -->
                        <div class="footer-items">
                            <!-- Footer Title -->
                            <h3 class="footer-title text-uppercase mb-2">Usluge</h3>
                            <ul>
                                <li class="py-2"><a href="#">Procena Vrednosti</a></li>
                                <li class="py-2"><a href="#">Studije Izvodljivosti</a></li>
                                <li class="py-2"><a href="#">Monitoring i Supervizija</a></li>
                                <li class="py-2"><a href="#">Investiciono Savetovanje</a></li>
                                <li class="py-2"><a href="#">Analize Portfolija</a></li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-12 col-sm-6 col-lg-3">
                        <!-- Footer Items -->
                        <div class="footer-items">
                            <!-- Footer Title -->
                            <h3 class="footer-title text-uppercase mb-2">Podrška</h3>
                            <ul>
                                <li class="py-2"><a href="#">Česta Pitanja</a></li>
                                <li class="py-2"><a href="#">Uslovi Poslovanja</a></li>
                                <li class="py-2"><a href="#">Centar za pomoć</a></li>
                                <li class="py-2"><a href="#">Karijera</a></li>
                                <li class="py-2"><a href="#">Kontakt</a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
export default {

}
</script>

<style>

</style>
